import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

interface RetentionRow {
  category: string;
  retention: string;
  reason: string;
}

/**
 * Public (no AuthGuard) account & data deletion information page.
 * Required for the Google Play Data Safety review — must be reachable without login.
 * Content is fully i18n-driven (DE/EN) via the `account_deletion.*` keys.
 */
@Component({
  selector: 'app-account-deletion',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './account-deletion.component.html',
  styleUrls: ['./account-deletion.component.scss'],
})
export class AccountDeletionComponent {
  private readonly translate = inject(TranslateService);

  readonly appSteps: number[] = [0, 1, 2, 3];

  get retentionRows(): RetentionRow[] {
    const rows = this.translate.instant('account_deletion.retention.rows');
    return Array.isArray(rows) ? rows : [];
  }

  switchLang(lang: 'de' | 'en'): void {
    this.translate.use(lang);
  }
}
